// User Module vuex
//import { apolloClient } from '@/apollo'

// Graph
//import { GetUser, GetWorkers, GetIssues, GetPremium } from '@/graphql/user'

// Routes
//import router from '@/router'

import axios from 'axios'

// State Module
const state = {
    version: '',
    content: '',
    activity: 0,
    cookieTtl: '720',
    loader: false
}

// Getters Module
const getters = {
}

// Actions Module
const actions = {
    loadFunction({commit}) {
        commit('setLoader', true)

        axios.get('/modalpage/get').then(({data}) => {
            if (data && (data._id)) {
                commit('setContent', data.content)
                commit('setActivity', data.activity)
                commit('setCookieTtl', data.cookieTtl)
                commit('setVersion', data.version || '')
            }
        }).catch(error => {
            console.log(error)
        }).finally(() => {
            commit('setLoader', false)
        })
    },

    // Save Function Action
    saveFunction({state, commit, dispatch}) {
        commit('setLoader', true)
        const params = {
            content: state.content || '',
            activity: state.activity ? 1 : 0,
            cookieTtl: isNaN(parseInt(state.cookieTtl)) ? 0 : parseInt(state.cookieTtl)
        }
        axios.post('/modalpage/save', params).then().catch(error => {
            console.log(error)
        }).finally(() => {
            commit('setLoader', false)
            dispatch('loadFunction');
        })
    }

}

// Mutations Module
const mutations = {
    // Set Loader File Mutation
    setLoader(state, value) {
        state.loader = value
    },
    // Set
    setContent(state, value) {
        state.content = value
    },
    // Set
    setActivity(state, value) {
        state.activity = value
    },
    // Set
    setCookieTtl(state, value) {
        state.cookieTtl = value+''
    },
    // Set
    setVersion(state, value) {
        state.version = value+''
    }
}

// Export Module
export default {
    root: true,
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
